import { LOCALES } from '../constants';

export default {
    [LOCALES.ENGLISH]: {
        //Menu
        'Menu-Top': 'Top',
        'Menu-ChangePassword': 'Change Password',
        'Menu-ExchangeRate': "Currency Rate",
        'Menu-SupervisorList': 'Supervisor List',
        'Menu-SupervisorAdd': 'Add Supervisor',
        'Menu-AdminList': 'Admin List',
        'Menu-AdminAdd': 'Add Admin',
        'Menu-TransactionList': 'Transaction List',
        'Menu-TransactionDetails': 'Transaction Details',
        'Menu-ExecutionList': 'Execution List',
        'Menu-OtcSell': 'Otc Sell',
        'Menu-DepositWithdraw': 'Deposit/Withdraw',
        'Menu-DepositWithdrawList': 'Deposit/Withdraw List',
        'Menu-DepositWithdrawDetails': 'Deposit/Withdraw Details',
        'Menu-DepositList': 'Deposit Process',
        'Menu-DepositModify': 'Modify Deposit',
        'Menu-DepositAdd': 'Add Deposit',
        'Menu-DepositImport': 'Import Deposit',
        'Menu-WithdrawList': 'Withdraw Process',
        'Menu-WithdrawModify': 'Modify Withdraw',
        'Menu-UserBalanceList': 'User Balance List',
        'Menu-ClientList': 'CASP List',
        'Menu-ClientModify': 'Modify CASP',
        'Menu-TrancheList': 'Tranche List',
        'Menu-TrancheAdd': 'Add Tranche',
        'Menu-TrancheModify': 'Modify Tranche',
        'Menu-AgathaConfiguration': 'AGATHA Configuration',
        'Menu-User': 'User',
        'Menu-UserList': 'User List',
        'Menu-UserDetailsList': 'User Details List',
        'Menu-UserModify': 'Modify User',
        'Menu-UserDetailsModify': 'Modify User Details',
        'Menu-UserChangeRequestList': 'Change Request List',
        'Menu-UserChangeRequestModify': 'Change Request',
        'Menu-PromoterList': 'Progress Associator List',
        'Menu-PromoterModify': 'Modify Progress Associator',
        'Menu-UserInfoRequestList': 'UserInfo Request List',
        'Menu-UserInfoRequestModify': 'Modify UserInfo Request',
        'Menu-Log': 'Log',
        'Menu-UserLoginList': 'User Login',
        'Menu-AdminLoginList': 'Admin Login',
        'Menu-AdminActionLogList': 'Admin Action Log',
        'Menu-AdminActionLog': 'Admin Action Log',
        'Menu-CommissionRate': 'Commission Rate',
        'Menu-Trading': 'Trading',
        'Menu-Account': 'Account',
        'Menu-AccessRights': 'Access Rights',
        'Menu-AdminAccessRights': 'Admin Access Rights',
        'Menu-DefaultAccessRights': 'Default Access Rights',
        'Menu-CASPAccessRights': 'CASP Access Rights',
        'Menu-SupervisorAccessRights': 'Supervisor Access Rights',
        'Menu-SettlementTransactionList': 'Settlement Transaction',
        'Menu-CancelRefundList': 'Cancel Refund List',
        'Menu-CancelRefundModify': 'Modify Cancel Refund',
        'Menu-UserBlockList': 'Block List',
        'Menu-UserBlockListAdd': 'Add Block List',
        'Menu-UserBlockListModify': 'Modify Block List',
        'Menu-SupervisorLoginList': 'Supervisor Login',
        'Menu-SupervisorActionLogList': 'Supervisor Action Log',
        'Menu-SupervisorActionLog': 'Supervisor Action Log',
        'Menu-IssuerConfiguration': 'Issuer Configuration',

        //Login
        'Email-Address': 'Email Address',
        'Password': 'Password',
        'Logout': 'Logout',
        'Home': 'Home',
        'OTP': 'OTP',
        'MFASetup-Message': 'Download Google Authenticator App on your Android or IOS device and install. Once installed scan the below code.',
        //Password Change
        'Old-Password': 'Old Password',
        'New-Password': 'New Password',
        'Confirm-Password': 'Confirm Password',
        'password-eligibility-message': 'Password should be minimum 10 letters, and include lower case letter, upper case letter, number, and special characters. Password should not contain user name or common words.',
        'Password-Expired-Message': 'Your login password has expired and must be changed.',
        'Password-Change-Success-Message1': 'Your login password has successfully changed.',
        'Password-Change-Success-Message2': 'Please click here to continue.',
        //Currency
        'Agatha': 'AGATHA',
        'Euro': 'EUR',
        'Bitcoin': 'BTC',
        'Euro-Agatha': 'EUR/AGATHA',
        'Bitcoin-Agatha': 'BTC/AGATHA',
        //Button
        'btnUpdate': 'Update',
        'btnSearch': 'Search',
        'btnAddNew': 'Add',
        'btnImport': 'Import',
        'btnGoToDepositProcess': 'Go To Deposit Process',
        'btnBack': 'Back',
        'btnClear': 'Clear',
        'btnSuspiciousTransaction': 'Suspicious Transaction',
        'btnViewUserDetails': 'View User Details',
        'btnSubmit': 'Submit',
        'btnVerify': 'Verify',
        'btnApprove': 'Approve',
        'btnCancel': 'Cancel',
        //Others        
        'Update-Success-Message': 'Successfully Updated',
        'Status-Active': 'Active',
        'Status-InActive': 'InActive',
        'Comments': 'Comments',
        'Days': 'Days',
        'CreatedByUser': 'Created By',
        'VerifiedDate': 'Verified Date',
        'VerifiedByUser': 'Verified By',
        'ApprovedDate': 'Approved Date',
        'ApprovedByUser': 'Approved By',
        //Search
        'Filters': 'Filters',
        'Search-All': 'All',
        'SearchField': 'Search Field',
        'Select-SearchField': 'Select Search Field',
        'SearchKeyword': 'Search Keyword',
        'Search-CASPID': 'CASP ID',
        'Search-UserType': 'User Type',
        'Search-KycStatus': 'KYC Status',
        'Search-DateFrom': 'Date From',
        'Search-DateTo': 'Date To',
        'Search-ProcessStatus': 'Select Process Status',
        'Search-BuySell': 'Buy/Sell',
        'Search-OTC': 'OTC',
        'Search-TransactionStatus': 'Status',
        'Search-Quantity': 'Quantity',
        'Search-Currency': 'Currency',
        'Search-TransactionType': 'Select Type',
        'Search-CASP': 'CASP',
        'Search-SelectCASP': 'Select CASP',
        'Search-SelectPaymentType': 'Select Payment Type',
		'Search-Suspicious': 'Suspicious Txn',
        //Home
        'MarketPrice': 'Market Price',
        'Symbol': 'Symbol',
        'LastPrice': 'Last',
        'Date-MLT': 'Date(MLT)',
        'HighPrice': 'High',
        'LowPrice': 'Low',
        'CustomerSignups': 'Customer Signups:',
        'Weekly': 'Weekly',
        'Monthly': 'Monthly',
        'Yearly': 'Yearly',
        'KYCApplications': 'KYC Applications:',
        'KycCompleted': 'KYC Completed',
        'KycPending': 'KYC Pending',
        'KycRejected': 'KYC Rejected',
        'DepositWithdrawRequest': 'Deposit/Withdraw Request:',
        'IVFAOBuy': 'IVFAO Buy:',
        'RecentExecutions': 'Execution History:',
        'TopAgathaBalance': 'AGATHA Balance:',
        'TopEuroBalance': 'Euro Balance:',
        'TopBitcoinBalance': 'Bitcoin Balance:',
        //CASP
        'RepresentativeName': 'Representative Name',
        'RepresentativeMailID': 'Representative EMail',
        'RepresentativePhoneNumber': 'Representative Phone',
        'UserLogin': 'User Login',
        'AdminLogin': 'Admin Login',
        'UserPasswordExpiryDays': 'User Password Expiry',
        'AdminPasswordExpiryDays': 'Admin Password Expiry',
        'SupervisorPasswordExpiryDays': 'Supervisor Password Expiry',
        'AutoBuyBackDays': 'Auto Buy Back',
        'AutoCancel': 'Auto Cancel',
        //Admin List
        'AdminID': 'Admin ID',
        'MailID': 'EMail',
        'AdminName': 'Admin Name',
        'AdminRole': 'Role',
        'Status': 'Status',
        'CreatedDate': 'Created Date',
        //User List
        'ClientID': 'CASP ID',
        'UserID': 'User ID',
        'UserType': 'User Type',
        'User': 'User',
        'Promoter': 'Progress Associator',
        'Distributor': 'Associator',
        'ReferredUser': 'Referred User',
        'UserName': 'User Name',
        'Gender': 'Gender',
        'PhoneNumber': 'Phone Number',
        'DOB': 'DOB',
        'UserStatus': 'Status',
        'Reason': 'Comment',
        'FounderAccount': 'Founder Account',
        //User Details
        'FirstNameJP': 'First Name(JP)',
        'LastNameJP': 'Last Name(JP)',
        'Nationality': 'Nationality',
        'Address1': 'Address(Prefecture, City, Ward)',
        'Address2': 'Address(Street, building, room)',
        'Address1JP': 'Address in Japanese',
        'Address2JP': 'Address in Japanese',
        'ZipCode': 'Zip Code',
        'Country': 'Country',
        'Passport': 'Passport',
        'PassportImage': 'Passport',
        'PassportBack': 'Passport Back',
        'PassportNumber': 'Passport No',
        'PassportExpiryDate': 'Passport Expiry Date',
        'NationalID': 'National Card',
        'NationalIDBack': 'National Card Back',
        'NationalIDExpiryDate': 'National Card Expiry Date',
        'NationalIDNumber': 'National Card NUmber',
        'DriversLicense': 'Driver\'s License',
        'DriversLicenseBack': 'Driver\'s License Back',
        'LicenseExpiryDate': 'License Expiry Date',
        'LicenseNumber': 'License Number',
        'Photo1': 'Applicant Photo',
        'Photo2': 'Profile Photo',
        'KycStatus': 'Kyc Status',
        'KycValidationStatus': 'Kyc Validation Status',
        'KycValidationError': 'Kyc Validation Error',
        'Remarks': 'Remarks',
        'KycApprovedUser': 'Kyc Approver',
        'UpdatedByUser': 'Updated User',
        'Recommender': 'Recommender',
        'Coupon': 'Coupon',
        //Change Request
        'FieldName': 'Field Name',
        'OldValue': 'Old Value',
        'NewValue': 'New Value',
        'RequestNo': 'Request No',
        //CASP Client
        'VFASPID': 'CASP ID',
        'ClientName': 'Name',
        //User Balance
        'Currency': 'Currency',
        'Balance': 'Balance',
        'LastUpdated': 'Last Updated',
        //Cash Transaction
        'DateReceived': 'Received Date',
        'BankReference': 'Bank Reference',
        'ErrorMessage': 'Error',
        //Error
        'ServerError': 'Error! Contact Support',

        //Signup
        'Signup-Title': 'Create New Account',
        'FirstName': 'First Name',
        'LastName': 'Last Name',
        'EmailAddress': 'Your Email',
        'RepeatPassword': 'Repeat Password',
        'PromotionalCode': 'Promotional Code',
        'SignUp': 'SignUp',
        'Login': 'Login',
        'Send': 'Send',
        'AlreadyMember': 'Already a member?',
        'SignUpSuccess-Message1': 'Thank you for your application.',
        'SignUpSuccess-Message2': 'We have sent the URL for account registration to the email address you input. Please click on the registration URL to validate your email address.',
        'SignUpSuccess-Message3': 'Download Google Authenticator App on your Android or IOS device and install. Once installed scan the below code.',
        'SignUpSuccess-Message4': 'After Scan is complete',

        // Tranche
        'TrancheID': 'Tranche ID',
        'TrancheName': 'Tranche Name',
        'Token': 'Token',
        'TokenReleased': 'Token Released',
        'TrancheRate': 'Rate',
        'PendingOrders': 'Pending Orders',
        'PendingBonus': 'Pending Bonus',
        'TokenRemaining': 'Token Remaining',
        'TokenSold': 'Token Sold',
        'Bonus': 'Bonus',
        'FounderReserve': 'Founder Reserve',
        'StartDate': 'Start Date',
        'EndDate': 'End Date',

        //CashTransacton
        'CashTransactionType': 'Type',
        'ReceivedDate': 'Received Date',
        'ProcessDate': 'Process Date',
        'Amount': 'Amount',
        'ProcessStatus': 'Status',
        'TransactionID': 'Transaction ID',
        'TransferNote': 'Note',
        'ModifiedDate': 'Modified Date',
        'ProcessedDate': 'Process Date',
        'ProcessByUser': 'Process User',
        'Deposit': 'Deposit',
        'Withdraw': 'Withdraw',
        'Cash': 'Cash',
        'CreditCard': 'Card',

        //Transacton
        'TransactionStatus': 'Status',
        'BuySell': 'Buy/Sell',
        'Tokens': 'Tokens',
        'UnitPrice': 'Rate',
        'Buy': 'Buy',
        'Sell': 'Sell',
        'Transaction-Buy': 'Buy',
        'Transaction-Sell': 'Sell',
        'Transaction-Gift': 'Gift',
        'Transaction-Bonus': 'Bonus',
        'From': 'From',
        'To': 'To',
        'FROM-bids': 'From',
        'Txn-Completed': 'Txn Completed',
        'Txn-Pending': 'Txn Pending',
        'Txn-Progress': 'Txn Progress',
        'Txn-Cancelled': 'Txn Cancelled',
        'Txn-Declined': 'Txn Declined',
        'Txn-Expired': 'Txn Expired',
        'Txn-Error': 'Txn Error',
        'Quantity': 'Quantity',
        'DateTime': 'Date(MLT)',
        'Commission': 'Commission',
        'GasFee': 'Gas Fee',
        'EstimatedGasFee': 'Estimated Gas Fee',
        'Currency-Euro': 'Euro',
        'Currency-Bitcoin': 'Bitcoin',
        'FromWalletID': 'From Wallet',
        'ToWalletID': 'To Wallet',
        'BlockchainTransactionID': 'Kadena Transaction ID',
        'BlockchainRequestKey': 'Kadena Request Key',
        'Suspicious': 'Suspicious',
        'Status-Requested': 'Requested',
        'Status-Rejected': 'Rejected',
        'Status-Approved': 'Approved',
        'UserDetails': 'User Details',
        'PaymentType': 'Payment Type',
        'AGATHA-Token-Balance': 'AGATHA Token Balance',
        'Order-Quantity': 'Quantity',
        'Payment-Amount': 'Payment Amount',
        'Partial-Order': 'Partial Order',
        'public-purchase-price': 'Public Purchase Price',
        'To-Confirm-Page': 'Confirm',
        'Rate': 'Rate',

        //Commission
        'OrderType-Open': 'Open',
        'OrderType-Settlement': 'Settlement',
        'CommissionCalcType': 'Calc Type',
        'CommissionCalcType-Quantity': 'By Quantity',
        'CommissionCalcType-Percentage': 'By Percentage',

        //Log
        'LoginDate': 'Login Date',
        'LogoutDate': 'Logout Date',
        'LoginStatus': 'Login Status',
        'LogoutType': 'Logout Type',
        'IPAddress': 'IP Address',

        //Access Rights
        'PageName': 'Page Name',
        'ReadAccess': 'Read',
        'WriteAccess': 'Write',
        'DeleteAccess': 'Delete',
        'ImportAccess': 'Import',
        'ExportAccess': 'Export',
        'VerifyAccess': 'Verify',
        'ApprovalAccess': 'Approve',
        'SelectAll': 'All',

        //'Menu-Statement': 'Statement',
        //'Menu-Account': 'Account',
        //'Menu-KYCApplication': 'KYC Application',
        //'Menu-AccountDetail': 'Account Details',
        //'Menu-WithdrawBankAccount': 'Withdraw Bank Account',        
        //'Menu-Notification': 'Notification',
        //'Menu-WalletAddress': 'Wallet Address',
        //'Menu-ReferralCode': 'Referral Code',        
        /*'Title-Deposit': 'Deposit Account',
        'Menu-BitCoinApplication': 'Bitcoin Wallet Application',
        'Menu-Bitcoin-Transfer': 'Bitcoin Transfer',
        'Title-WithdrawAccount': 'Withdrawal Bank Account',
        'Title-PromoterApplication': 'Progress Associator Application Form',
        'Title-PromoterCoupon': 'Register Referral Code',
        'Title-SellTokens-Settlement': 'OTC List',     */
    },
};